import { Directive, Input } from '@angular/core';
import { AsyncValidatorFn, AsyncValidator, NG_ASYNC_VALIDATORS, AbstractControl, ValidationErrors } from '@angular/forms';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TmsApiService } from '../services/tms-api/tms-api.service';
import { Constants } from '../constants';
import { throwError } from 'rxjs';

/**
 * Custom Control Validetor For Visual IDs
 * @return AsyncValidatorFn
 */
export function tmsVisualIdValidator(tmsService: TmsApiService, visualIdIndex: number): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const errorObject = {};
    const visualId = control.value.replace(/\s/g, '');

    return tmsService.validateVisualIdWithParameter(visualId).pipe(
      map((res) => {
        const successfulResponse = [
          Constants.TICKET_LINKED,
          Constants.TICKET_UNLINKED
        ];

        // @TODO improve the validation over response object
        if (successfulResponse.indexOf(res.status) !== -1 && res.hasOwnProperty('linked')) {
          tmsService.addEntitlement(res, visualIdIndex);

          return null;
        } else {
          tmsService.removePreviousValidVid(visualIdIndex);
          errorObject[res.status] = true;

          return errorObject;
        }
      }),
      catchError((error) => {
        errorObject[Constants.VALIDATE_GENERIC_ERROR] = true;
        control.setErrors(errorObject);

        return throwError(error);
      })
    );
  };
}

@Directive({
  selector: '[appTmsVisualIdValidator][ngModel]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: TmsVisualIdValidatorDirective,
      multi: true
    }
  ]
})
export class TmsVisualIdValidatorDirective implements AsyncValidator {
  @Input() visualIdIndex: number;

  constructor(private _tmsApiService: TmsApiService) { }

  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return tmsVisualIdValidator(this._tmsApiService, this.visualIdIndex)(control);
  }

}
